var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c(
        "el-form-item",
        { attrs: { label: _vm.showLabel ? "所属机构" : "" } },
        [
          _c("team-tree", {
            staticClass: "filter-item",
            attrs: {
              "show-checkbox": "",
              singleChoose: _vm.singleChoose,
              checkStrictly: _vm.checkStrictly,
              width: "230",
            },
            on: { input: _vm.input },
            model: {
              value: _vm.teamCodeList,
              callback: function ($$v) {
                _vm.teamCodeList = $$v
              },
              expression: "teamCodeList",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isShowCarNo === true,
              expression: "isShowCarNo === true",
            },
          ],
          attrs: { label: _vm.showLabel ? "车牌号" : "" },
        },
        [
          _c(
            "el-select",
            {
              ref: "selectlazyload",
              staticClass: "search-item filter-item",
              attrs: {
                "collapse-tags": "",
                clearable: "",
                multiple: "",
                filterable: "",
                "filter-method": _vm.filtermethod,
                placeholder: "请选择车牌号",
              },
              on: { change: _vm.change },
              model: {
                value: _vm.carNoList,
                callback: function ($$v) {
                  _vm.carNoList = $$v
                },
                expression: "carNoList",
              },
            },
            _vm._l(_vm.truckNoList, function (item) {
              return _c("el-option", {
                key: item.vin,
                attrs: { label: item.label, value: item.value },
              })
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }